<div class="recent-news">
<div class="news-item">
<img loading="lazy" class="newsfeed-thumbnail" src="/assets/newsfeed/fly-query-32x32.png"/>
<h4 id="flyquery"><strong>FlyQuery</strong></h4>
<p><em>2026-08-15</em></p>
<p><a routerLink="/query">Advanced Search </a></p>

</div>

<div id="archive-link"><a routerLink="/news/">News archive ...</a></div>
</div>

